import React from 'react';

import fetch from '../fetch';

import utils from '../../utils';

import {Modal, message,Progress,Tag,Popover} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号', width: 75},
    {key:'taskCode', label: '任务编号'},
    {key:'taskName', label: '任务名称',render: (value,row) =>
    <span> 
        <Popover placement="topLeft" style={{ width: 300 }}  content={
            <div style={{ width: 200 }}>
                {
                    row.taskContent
                }
            </div>} 
            title="任务内容"
            >
            {value}
        </Popover>
    </span> },
    {key:'categoryName', label: '任务类别',render: (value,row) =>
    <span> 
        <Popover placement="topLeft" style={{ width: 300 }}  content={
            <div style={{ width: 200 }}>
                {
                    row.categoryPathStr
                }
            </div>} 
            title="分类路径"
            >
            {value}
        </Popover>
    </span> 
    },
    {key:'taskType', label: '任务类型', width: 90, render:(d) => (
        +d === 1 ? <Tag color='#52c41a'>直发任务</Tag> 
    : +d === 2 ? <Tag color='#3CC4C4'>分发任务</Tag> 
    : '' )},
    {key:'distributeType', label: '分发类型', width: 90, 
    render: (value) => value === 1 ? 
    <span className='orangeclass'>部门任务</span> : value === 2 ? 
    <span className='blueclass'>个人任务</span> :''},
    {key:'taskTarget', label: '目标要求'},
    {key:'warningStatus', label: '预警状态', width: 90, 
    render: (value,row) => value == "1" ? 
    <span className='redclass'>督办预警</span> :value == "2" ? 
    <span className='yellowclass'><Popover placement="topLeft" style={{ width: 300 }}  content={
        <div style={{ width: 200 }}>
            {
                row.warningDesc
            }
        </div>} 
        title="预警详情"
        >
        <img width={'20px'} height={'20px'} src='/images/yellow.svg'></img>预警
    </Popover></span> :value == "3" ? 
    <span className='orangeclass'><Popover placement="topLeft" style={{ width: 300 }}  content={
        <div style={{ width: 200 }}>
            {
                row.warningDesc
            }
        </div>} 
        title="预警详情"
        >
        <img width={'20px'} height={'20px'} src='/images/orange.svg'></img>预警
    </Popover></span> :value == "4" ? 
    <span className='redclass'><Popover placement="topLeft" style={{ width: 300 }}  content={
        <div style={{ width: 200 }}>
            {
                row.warningDesc
            }
        </div>} 
        title="预警详情"
        >
        <img width={'20px'} height={'20px'} src='/images/red.svg'></img>预警
    </Popover></span>: ''},
    {key:'progressValue', label: '任务进度' ,
            render:(value) => <Progress percent={parseInt(value)} />  },
    {key:'taskStatus', label: '任务状态', width: 90, 
            render: (value) => value === "CREATE" ?
            <Tag color='#3CC4C4'>创建</Tag>  : value === "APPROVAL" ?
            <Tag color='#722ed1'>待审批</Tag> : value === "ACTIVE" ?
            <Tag color='#1890ff'>处理中</Tag> : value === "END" ?
            <Tag color='#52c41a'>结束</Tag> : value === "AUDIT" ?
            <Tag color='#722ed1'>待审核</Tag> : value === "EXPIRED" ?
            <Tag color='#f5222d'>已逾期</Tag> : '' },
    {key:'timeType', label: '时间要求', width: 90, render: (value) => value === "ORDINARY" ?
    '一般'   : value === "TIMELIMIT" ?
    '限时' : '' },
    {key:'orgName', label: '主办单位'},
    {key:'organizerName', label: '协办单位'},
    {key:'approvalOrgName', label: '审批单位'}, 
    {key:'auditOrgName',label:'审核单位'},
    {key:'createUserName', label: '创建人'},
    {key:'createDate', label: '创建时间'},
    {key:'employeeName', label: '负责人'},
    {key:'toUserName',label:'责任人(协同人)'},
    {key:'approvalUserName',label:'审批人'},
    {key:'auditUserName',label:'审核人'},
    {key:'importanceLevel', label: '重要性', width: 75, 
            render: (value) => value === "MAJOR" ? 
            <span className='redclass'>重要</span> : value === "MINOR" ?  
            '一般': ''},
    {key:'priorityLevel', label: '紧急度', width: 75, 
            render: (value) => value === "HIGH" ? 
            <span className='orangeclass'>高</span> : value === "CRASH" ? 
            <span className='redclass'>紧急</span> : value === "NORMAL" ? 
            '中' : value==="LOW" ?
            '低' :''},
    {key:'startDate', label: '开始时间'},
    {key:'endDate', label: '结束时间'},
    {key:'lastUpdateDate', label: '更新时间'},
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('supv/tasksummary/query', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false,
            name: d.taskName
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const querySearchById = (id) => {
    return fetch.get('supv/taskcreate/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

const querySupvEnum = (enumName) => {
    return fetch.post('platform/code/supv/getEnum', enumName)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: d.key,
                label: d.label
            }
        });
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
 const update = (id, data) => {
    return fetch.post('supv/tasksummary/update/' + id, data)
    .then(response => {
        return response;
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

const delSummary = (id, data) => {
    return fetch.post('supv/tasksummary/delSummary/' + id, data)
    .then(response => {
        return response;
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

const sendMessage = (id, data) => {
    return fetch.post('supv/tasksummary/sendMessage/' + id, data)
    .then(response => {
        return response;
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'employee'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

const deleteFile = (dataList) => {
    const ids = dataList.map(d => d.id);
    return fetch.post('supv/tasksummary/file/delete', ids);
}

export default {
    upload: `${fetch.base}supv/tasksummary/file`,
    deleteFile,
    querySearch,
    columns,
    onSelect,
    update,
    onSelectData,
    setRefresh,
    redirect,
    getSelection,
    getSelectionData,
    querySupvEnum,
    querySearchById,
    sendMessage,
    delSummary
}